export default import.meta.ROLLUP_FILE_URL_HAwZnQ40A17rYC3Q$lxt9A;